/**
 * @injectDirectionClass
 * will inject 'vuesax-app-is-ltr' (ltr case) or 'vuexsax-app-is-rtl' (rtl case) in the html tag
 */

export const injectDirectionClass = dir => {
  if (document) {
    if (dir) {
      document.documentElement.classList.remove('vuesax-app-is-ltr');
      document.documentElement.classList.add('vuesax-app-is-rtl');
    } else {
      document.documentElement.classList.add('vuesax-app-is-ltr');
      document.documentElement.classList.remove('vuesax-app-is-rtl');
    }
  }
};
